/* unplugin-vue-components disabled */
import {FilterContext} from 'mixins'

export default {
  mixins: [FilterContext.mixin],
  props: {
    minDate: {type: Date, default: undefined}
  },
  data() {
    return {
      // TODO: primevue 3 version has a bug with modelvalue, 
      // it works normally only with the initial parameter null. 
      // we will need to rewrite the code after the update.
      dates: null,
    }
  },
  computed: {
    first(){
      return this.dates && this.dates[0] && $utils.format.date(this.dates[0])
    },
    last(){
      return this.dates && this.dates[1] && `- ${$utils.format.date(this.dates[1])}`
    }
  },
  watch: {
    prev(){
      this.dates = this.prev.length ? this.prev : null
    },
    dates(){
      if (this.dates?.some(d => !d)) return
      this.next = this.dates || []
    }
  },
}
